import { render, staticRenderFns } from "./PriceByTypeForm.vue?vue&type=template&id=16ea5c40"
import script from "./PriceByTypeForm.vue?vue&type=script&lang=ts"
export * from "./PriceByTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports